export default __webpack_public_path__ + "72d6f3710a161a44ad56c2f40e33e939.png";